import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TodayIcon from '@mui/icons-material/Today';
import DateRangeIcon from '@mui/icons-material/DateRange';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

/**
 * Shared urgency choices used by the service search timing step and custom storefront inquiries.
 * `id` is stored as `formData.urgency`; the `asap` / `today` / `few-days` ids match business `Availability`.
 *
 * - `label` — custom inquiry modal and saved-request summaries
 * - `searchLabel` — service search timing step, result chips, and the contact sheet
 * - `availabilityWindows` — show providers whose `Availability` includes any of these; `null` = no filter
 */
export const WIZARD_URGENCY_OPTIONS = [
  {
    id: 'asap',
    label: 'As soon as possible',
    searchLabel: "ASAP, it's urgent",
    icon: WarningAmberIcon,
    urgent: true,
    availabilityWindows: ['asap'],
  },
  {
    id: 'today',
    label: 'Today',
    searchLabel: 'Later today',
    icon: TodayIcon,
    availabilityWindows: ['asap', 'today'],
  },
  {
    id: 'few-days',
    label: 'Within the next few days',
    searchLabel: 'In the next few days',
    icon: DateRangeIcon,
    availabilityWindows: ['asap', 'today', 'few-days'],
  },
  {
    id: 'just-quotes',
    label: 'Just getting quotes',
    searchLabel: "I'm flexible",
    icon: RequestQuoteIcon,
    availabilityWindows: null,
  },
];

/**
 * @param {string | null | undefined} urgencyId
 * @returns {string}
 */
export function getWizardUrgencyLabel(urgencyId) {
  if (!urgencyId) return '—';
  return WIZARD_URGENCY_OPTIONS.find((o) => o.id === urgencyId)?.label ?? '—';
}

/**
 * @param {string | null | undefined} urgencyId
 * @returns {object | null}
 */
export function getWizardUrgencyOption(urgencyId) {
  if (!urgencyId) return null;
  return WIZARD_URGENCY_OPTIONS.find((o) => o.id === urgencyId) ?? null;
}
